import { Menu } from "@mantine/core";
import { IconEye } from "@tabler/icons-react";
import { useCallback } from "react";

interface Props {
  heldEmailId: string;
  onView: (id: string) => void;
}

export function HeldEmailViewActionItem({ heldEmailId, onView }: Props) {
  const handleClick = useCallback(
    () => onView(heldEmailId),
    [heldEmailId, onView]
  );
  return (
    <Menu.Item leftSection={<IconEye size={16} />} onClick={handleClick}>
      View email
    </Menu.Item>
  );
}
